<div class="form-panel-container">
    <form [formGroup]="formGroup">
        <div class="form-container" [ngClass]="{ readonly: _context?.mode === FormMode.Reading }">
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Nom</mat-label>
                    <input matInput data-input-name type="text" formControlName="name" autocomplete="off" required tabindex="1" />
                    @if (formGroupErrors?.name?.required && (formGroup.controls['name']?.dirty || formGroup.controls['name'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Nom' est obligatoire</mat-error>
                    }
                    @if (formGroupErrors?.name?.onlyWordAndDigit && (formGroup.controls['name']?.dirty || formGroup.controls['name'].touched)) {
                        <mat-error>Le champ 'Nom' ne doit contenir que des lettres et des chiffres</mat-error>
                    }
                </mat-form-field>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Le nom de l'attribut est utilisé comme identifiant unique. Il ne peut êre composé que de lettres et de chiffres"
                    tooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Libellé</mat-label>
                    <input matInput data-input-header type="text" formControlName="header" autocomplete="off" required tabindex="2" />
                    @if (formGroupErrors?.header?.required && (formGroup.controls['header']?.dirty || formGroup.controls['header'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Libellé' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    class="info-icon"
                    hubToolTip="Le libellé est utilisé dans les formulaires ainsi que comme en-tête de colonne dans les listes."
                    tooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Type</mat-label>
                    <mat-select data-select-type formControlName="type" (selectionChange)="onSelectionTypeChange()" required tabindex="3">
                        <mat-option data-select-listing-type-option [value]="2">Texte</mat-option>
                        <mat-option data-select-listing-type-option [value]="3">Nombre entier</mat-option>
                        <mat-option data-select-listing-type-option [value]="11">Nombre décimal</mat-option>
                        <mat-option data-select-listing-type-option [value]="1">Date</mat-option>
                        <mat-option data-select-listing-type-option [value]="8">Date & heure</mat-option>
                        <mat-option data-select-listing-type-option [value]="5">Couleur</mat-option>
                        <mat-option data-select-listing-type-option [value]="12">Adresse e-mail</mat-option>
                        <mat-option data-select-listing-type-option [value]="15">N° de téléphone</mat-option>
                        <mat-option data-select-listing-type-option [value]="4">Liste</mat-option>
                        <mat-option data-select-listing-type-option [value]="14">Autocompletion par API</mat-option>
                        <mat-option data-select-listing-type-option [value]="9">Client</mat-option>
                        <mat-option data-select-listing-type-option [value]="10">Utilisateur</mat-option>
                        <mat-option data-select-listing-type-option [value]="13">Lien</mat-option>
                    </mat-select>
                    @if (formGroupErrors?.type?.required && (formGroup.controls['type']?.dirty || formGroup.controls['type'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Type' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Le type permet de définir la donnée que contiendra l'attribut. En fonction du type, la donnée devra respecter un certain formalisme et/ou sera formattée d'une manière specifique. Le type le moins restrictive est le type 'Texte'.<ul><li><b>Texte : </b>Permet de stocker une donnée textuelle. A utiliser également lorsque l'on est pas sûr du formalisme des données qui seront stockées dans l'attribut.</li><li><b>Nombre entier : </b>Permet de stocker un nombre entier (sans partie décimale).</li><li><b>Nombre décimal : </b>Permet de stocker un nombre décimal (peut posseder une partie décimale).</li><li><b>Date : </b>Permet de stocker une date sans notion d'heure.</li><li><b>Date & heure : </b>Permet de stocker une date avec la notion d'heure.</li><li><b>Couleur : </b>Permet de stocker une couleur parmi une liste de couleurs prédéfinies</li><li><b>Adresse e-mail : </b>Permet de stocker une adresse e-mail. Cet attribut s'assure que la donnée contenue correspond à une adresse e-mail valide.</li><li><b>N° de téléphone : </b>Permet de stocker un n° de téléphone. Cet attribut s'assure que la donnée contenue correspond à un n° de téléphone valide.</li><li><b>Liste : </b>Permet de selectionner une valeur parmi une liste de valeurs définies.</li><li><b>Autocomplétion par API : </b>Permet de selectionner une valeur parmi une liste de valeurs fournies par une API tierce.</li><li><b>Client : </b>Permet de selectionner un client parmi les clients de l'organisation.</li><li><b>Utilisateur : </b>Permet de selectionner un utilisateur parmi les utilisateurs de l'organisation</li><li><b>Lien : </b>Permet de stocker un lien HTTP ou un chemin réseau UNC</li></ul>"
                    tooltipPosition="right"></fa-icon>
            </div>

            @if (formGroup.get('type').value === propertyType.AutocompletionByApi) {
                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>API fournissant la source de données</mat-label>
                        <mat-select data-select-configurationApiId formControlName="configurationApiId" required tabindex="4">
                            @for (item of _apiConfigurations; track item) {
                                <mat-option data-select-listing-type-option [value]="item.id">
                                    {{ item.name }}
                                </mat-option>
                            }
                        </mat-select>
                        @if (
                            formGroup.errors &&
                            formGroup.errors['configurationApiId']?.required &&
                            (formGroup.controls['configurationApiId']?.dirty || formGroup.controls['configurationApiId'].touched)
                        ) {
                            <mat-error data-input-role-error>Le champ 'API fournissant la source de données' est obligatoire</mat-error>
                        }
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Configuration d'API" matTooltipPosition="right"></fa-icon>
                </div>
            }

            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Format de saisie</mat-label>
                    <input matInput data-input-format type="text" formControlName="format" autocomplete="off" tabindex="5" />
                </mat-form-field>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Le format permet de specifier une contrainte que doit respecter la donnée saisie. Un format peut être spécifier pour les attributs de type 'Texte' et 'Nombre'. Le format est une expression régulière qui doit être respectée par la donnée saisie.<br>
                    Les adresses e-mail ainsi que les n° de téléphone ont un format prédéfini et n'ont pas besoin d'être spécifié."
                    tooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Format d'affichage</mat-label>
                    <mat-select data-select-type formControlName="displayFormat" required tabindex="6">
                        @if (selectedAttributeType === propertyType.DateAndTime) {
                            <mat-option data-select-listing-type-option [value]="3">Jour/Mois/Année Heures:Minutes:secondes</mat-option>
                            <mat-option data-select-listing-type-option [value]="4">Jour/Mois/Année Heures:Minutes</mat-option>
                            <mat-option data-select-listing-type-option [value]="5">Jour/Mois/Année Heures</mat-option>
                        }
                        @if (selectedAttributeType === propertyType.DateAndTime || selectedAttributeType === propertyType.Date) {
                            <mat-option data-select-listing-type-option [value]="1">Jour/Mois/Année</mat-option>
                            <mat-option data-select-listing-type-option [value]="2">Année-Mois-jour</mat-option>
                            <mat-option data-select-listing-type-option [value]="6">Jour/Mois</mat-option>
                        }
                        @if (selectedAttributeType === propertyType.PhoneNumber) {
                            <mat-option data-select-listing-type-option [value]="7">XXXXXXXXXX</mat-option>
                            <mat-option data-select-listing-type-option [value]="8">XX XX XX XX XX</mat-option>
                            <mat-option data-select-listing-type-option [value]="9">XX.XX.XX.XX.XX</mat-option>
                            <mat-option data-select-listing-type-option [value]="10">XX-XX-XX-XX-XX</mat-option>
                        }
                    </mat-select>
                    @if (formGroupErrors?.displayFormat?.required && (formGroup.controls['displayFormat']?.dirty || formGroup.controls['displayFormat'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Format d'affichage' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Le format d'affichage permet de specifier la manière dont la donnée doit être affichée dans la liste des dossiers ainsi que lorsqu'elle est publipostée (mail, SMS...).
                    <ul>
                    <li>Format des dates sans notion d'heure</li>
                    <ul>
                        <li><b>Jour/Mois/Année</b> Exemple : 19/05/2025</li>
                        <li><b>Année-Mois-jour</b> Exemple : 2025-05-19</li>
                        <li><b>Jour/Mois</b> Exemple : 19/05</li>
                    </ul>
                    <li>Format des dates avec notion d'heure</li>
                    <ul>
                        <li><b>Jour/Mois/Année Heures:Minutes:secondes</b> Exemple : 19/05/2025 15:33:56</li>
                        <li><b>Jour/Mois/Année Heures:Minutes</b> Exemple : 19/05/2025 15:33</li>
                        <li><b>Jour/Mois/Année Heures</b> Exemple : 19/05/2025 15</li>
                        <li><b>Jour/Mois/Année</b> Exemple : 19/05/2025</li>
                        <li><b>Année-Mois-jour</b> Exemple : 2025-05-19</li>
                        <li><b>Jour/Mois</b> Exemple : 19/05</li>
                    </ul>
                    <li>Format des n° de téléphone</li>
                    <ul>
                        <li><b>XXXXXXXXXX</b> Exemple : 0654876584</li>
                        <li><b>XX XX XX XX XX</b> Exemple : 06 54 87 65 84</li>
                        <li><b>XX.XX.XX.XX.XX</b> Exemple : 06.54.87.65.84</li>
                        <li><b>XX-XX-XX-XX-XX</b> Exemple : 06-54-87-65-84</li>
                    </ul>
                    </ul>"
                    tooltipPosition="right"></fa-icon>
            </div>

            @if (formGroup.get('type').value) {
                <div class="form-item form-item-help">
                    @if (formGroup.get('type').value === propertyType.Date) {
                        <mat-form-field class="with-info-icon">
                            <mat-label>Valeur par défaut</mat-label>
                            <input matInput [matDatepicker]="picker" formControlName="defaultValue" tabindex="7" />
                            @if (_context.mode !== FormMode.Reading) {
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            }
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    } @else if (formGroup.get('type').value === propertyType.DateAndTime) {
                        <mat-form-field class="with-info-icon">
                            <mat-label>Valeur par défaut</mat-label>
                            <input matInput [ngxMatDatetimePicker]="timepicker" formControlName="defaultValue" tabindex="7" />
                            @if (_context.mode !== FormMode.Reading) {
                                <ngx-mat-datepicker-toggle matSuffix [for]="timepicker"></ngx-mat-datepicker-toggle>
                            }
                            <ngx-mat-datetime-picker #timepicker></ngx-mat-datetime-picker>
                        </mat-form-field>
                    } @else {
                        <mat-form-field class="with-info-icon">
                            @if (formGroup.get('type').value === propertyType.Color) {
                                <mat-label>Couleur par défaut</mat-label>
                            } @else {
                                <mat-label>Valeur par défaut</mat-label>
                            }

                            @if (formGroup.get('type').value === propertyType.Long || formGroup.get('type').value === propertyType.Decimal) {
                                <input
                                    matInput
                                    data-input-defaultValue
                                    type="number"
                                    placeholder="Valeur par défaut"
                                    formControlName="defaultValue"
                                    autocomplete="off"
                                    tabindex="7" />
                            } @else if (formGroup.get('type').value === propertyType.List) {
                                @if (formGroup.get('custom').value === true) {
                                    <mat-select formControlName="defaultValue" tabindex="7">
                                        <mat-option [value]="">Aucune</mat-option>
                                        @for (attributeValue of attributeListValues; track attributeValue) {
                                            <mat-option [value]="attributeValue.id.toString()">{{ attributeValue.name }}</mat-option>
                                        }
                                    </mat-select>
                                }

                                @if (formGroup.get('name').value === 'FolderStateId') {
                                    <mat-select formControlName="defaultValue" tabindex="7">
                                        <mat-option [value]="">Aucune</mat-option>
                                        @for (state of folderStates; track state) {
                                            <mat-option [value]="state.id.toString()">{{ state.name }}</mat-option>
                                        }
                                    </mat-select>
                                }
                            } @else if (formGroup.get('type').value === propertyType.ListCustomers) {
                                <mat-select formControlName="defaultValue" tabindex="7">
                                    <mat-option [value]="">Aucune</mat-option>
                                    @for (attributeValue of attributeListValues; track attributeValue) {
                                        <mat-option [value]="attributeValue.id.toString()">{{ attributeValue.name }}</mat-option>
                                    }
                                </mat-select>
                            } @else if (formGroup.get('type').value === propertyType.ListUsers) {
                                <mat-select formControlName="defaultValue" tabindex="7">
                                    <mat-option [value]="">Aucune</mat-option>
                                    @for (user of userList; track user) {
                                        <mat-option [value]="user.id.toString()">{{ user.displayName }}</mat-option>
                                    }
                                </mat-select>
                            } @else if (formGroup.get('type').value === propertyType.Color) {
                                <mat-select formControlName="defaultValue" ngClass="bak-{{ formGroup.get('defaultValue').value }}-color" tabindex="7">
                                    <mat-option value="">Aucune</mat-option>
                                    <mat-option class="mat-option-green-color" value="green"></mat-option>
                                    <mat-option class="mat-option-orange-color" value="orange"></mat-option>
                                    <mat-option class="mat-option-red-color" value="red"></mat-option>
                                    <mat-option class="mat-option-grey-color" value="grey"></mat-option>
                                    <mat-option class="mat-option-light-blue-color" value="lightBlue"></mat-option>
                                    <mat-option class="mat-option-dark-blue-color" value="darkBlue"></mat-option>
                                </mat-select>
                            } @else if (formGroup.get('type').value === propertyType.AutocompletionByApi) {
                                <!-- TODO : A terme utiliser le composant d'autocompletion si c'est possible -->
                                <input matInput data-input-defaultValue type="text" formControlName="defaultValue" autocomplete="off" tabindex="7" />
                            } @else {
                                <input matInput data-input-defaultValue type="text" formControlName="defaultValue" autocomplete="off" tabindex="7" />
                            }
                            @if (formGroupErrors?.defaultValue?.pattern && (formGroup.controls['defaultValue']?.dirty || formGroup.controls['defaultValue'].touched)) {
                                <mat-error data-input-title-error>Le champ 'Valeur par défaut' est invalide</mat-error>
                            }
                        </mat-form-field>
                    }
                    <fa-icon
                        [icon]="faCircleInfo"
                        class="info-icon"
                        hubToolTip="La valeur par défaut est la valeur avec laquelle l'attribut sera initialisé lors de la création d'un nouveau dossier. Cette valeur pourra être modifiée par la suite par le système ou l'utilisateur."
                        tooltipPosition="right"></fa-icon>
                </div>
            }

            @if (_context.mode !== FormMode.Creation) {
                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Ordre</mat-label>
                        <input matInput data-input-order type="number" formControlName="order" autocomplete="off" required tabindex="8" />
                        @if (formGroupErrors?.order?.required && (formGroup.controls['order']?.dirty || formGroup.controls['order'].touched)) {
                            <mat-error data-input-title-error>Le champ 'Ordre' est obligatoire</mat-error>
                        }
                    </mat-form-field>
                    <fa-icon
                        [icon]="faCircleInfo"
                        class="info-icon"
                        hubToolTip="L'ordre indique la position du champ correspondant à cet attribut dans les formulaires de saisie (ainsi que dans les favoris). L'ordre est modifiable à partir de l'écran listant les attributs."
                        tooltipPosition="right"></fa-icon>
                </div>
            }

            <div class="form-item form-item-help">
                <mat-checkbox class="with-info-icon accent-button" formControlName="enable" tabindex="9">Actif</mat-checkbox>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Un attribut peut être rendu inactif pour indiquer qu'il est obsolète. C'est à dire qu'il ne pourra plus être renseigné par l'utilisateur ou le système. Pour autant si cet attribut est déjà renseigné, sa valeur sera visible."
                    tooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-checkbox class="with-info-icon accent-button" formControlName="custom" tabindex="10">Personnalisé</mat-checkbox>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Un attribut personnalisé est un attribut qui est géré par votre organisation. Contrairement aux attributs système qui sont communs à toutes les organisations et ne peuvent pas être modifiés."
                    tooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-checkbox class="with-info-icon accent-button" formControlName="mandatory" tabindex="11">Obligatoire</mat-checkbox>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Un attribut obligatoire non renseigné n'empêche par la sauvegarde du dossier. Il est toutefois signalé comme devant être renseigné dans le formulaire. <br>De plus il peut permettre de conditionner l'execution d'une action de workflow au fait qu'il soit renseigné"
                    tooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-checkbox class="with-info-icon accent-button" formControlName="isFavorite" tabindex="12">Favoris</mat-checkbox>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Si cette option est activée, l'attribut sera également affiché dans le bandeau Favoris du détail du dossier. Cela permet de mettre en avant les attributs les plus importants."
                    tooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-checkbox class="with-info-icon accent-button" formControlName="displayedInCreationForm" tabindex="13">Afficher à la création</mat-checkbox>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Si cette option est activée, l'attribut sera présent dans le formulaire de création d'un nouveau dossier. Sinon, il ne sera accessible que lors de la modification du dossier."
                    tooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-checkbox class="with-info-icon accent-button" formControlName="usedBySearch" tabindex="14">Utilisé par la recherche</mat-checkbox>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Lorsque cette option est activée, la recherche de texte à partir de la liste des dossiers effectuera une recherche dans le contenu de cette attribut; sinon il sera ignoré.<br>Pour améliorer les performances, il est recommandé de ne pas activer cette option pour les attributs contenant des données non pertinentes pour la recherche."
                    tooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-checkbox class="with-info-icon accent-button" formControlName="invisible" (change)="onInvisibleOptionChange($event)" tabindex="15">
                    Non visible dans l'interface utilisateur
                </mat-checkbox>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Si cette option est activée, l'attribut ne sera pas visible dans l'interface utilisateur (que ce soit dans les formulaires ou les listes). Il pourra toutefois être utilisé par les processus et dans le workflow."
                    tooltipPosition="right"></fa-icon>
            </div>

            <button mat-stroked-button class="accent-button" (click)="displayOptions()" tabindex="16">Options...</button>
        </div>
    </form>
    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" (click)="cancel()" tabindex="17">Annuler</button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="formGroup.disabled || formGroup.invalid"
            [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }"
            (click)="manualSave()"
            tabindex="18">
            Enregistrer
        </button>
    </div>
</div>
